import { type SearchView } from '@/types/schema/views/SearchView';
import { useViewContext } from '@/components/views/ViewContext';
import { SearchInput } from './SearchInput';

export function getSearchInputsLayoutClassNames(searchInputsColumns: number) {
  const columnsLayout: Record<number, string> = {
    1: 'grid gap-4',
    2: 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2',
    3: 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'
  };
  const inputsColumns =
    searchInputsColumns < 1 || searchInputsColumns > 3 ? 3 : searchInputsColumns;
  return columnsLayout[inputsColumns];
}

export function SearchInputs() {
  const { view } = useViewContext<SearchView>();

  return (
    <div className={getSearchInputsLayoutClassNames(view.groups[0].columns.length)}>
      {view.groups[0].columns.map((column) => (
        <div key={column.id} className="flex flex-1 flex-col gap-4">
          {column.fields.map((input) => (
            <SearchInput key={input.id} input={input} />
          ))}
        </div>
      ))}
    </div>
  );
}
